import { Pipe, PipeTransform } from '@angular/core';
import { ORDER_MODE } from '@app/_shared/shared.enums';

@Pipe({
  name: 'orderMode'
})
export class OrderModePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    if (typeof(value)==='number') {
      return ORDER_MODE[value]
    }
    return value
  }

}
